import { ApiClient } from "../../account/models/ApiClient";
import { AdminSurvey } from "../../survey/models/Survey";
import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminSurveyApi = {
  page: async (pageSize: number, pageNumber: number) =>
    await jwtAuthAxios().get<Page<AdminSurvey>>(`/admin/surveys`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  put: async (surveyId: string, data: Partial<AdminSurvey>) =>
    await jwtAuthAxios().put<AdminSurvey>(`/admin/surveys/${surveyId}`, data),

  triggerTroubleshoot: async (surveyId: string) => {
    return await jwtAuthAxios().post<ApiClient[]>(
      `/admin/surveys/${surveyId}/trigger-troubleshoot`,
    );
  },
};
